/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgFileAdd = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        d="M4 2h10.414L20 7.586V14h-2V9h-5V4H6v16h8v2H4V2zm11 3.414V7h1.586L15 5.414zM18 20v2h2v-2h2v-2h-2v-2h-2v2h-2v2h2z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgFileAdd as FileAdd };
